import { useDisclosure } from '@mantine/hooks';
import { createContext, useContext, useState } from 'react';
import PickDevicesModal, { PickDevicesModalFormValues } from 'components/modals/pick-devices-modal/PickDevicesModal';

interface PickDevicesParams {
  title: string;
  alreadyPickedDeviceIds: number[];
  revisionDeviceTypeId: number;
  departmentId: number;
  onPick: (value: PickDevicesModalFormValues) => void;
}

type PickDevices = (params: PickDevicesParams) => void;

interface IPickDevicesContext {
  pickDevices: PickDevices;
}

const PickDevicesContext = createContext<IPickDevicesContext>(undefined!);

/**
 * Provider for selecting the list of devices.
 */
export function PickDevicesProvider({ children }: { children: React.ReactNode }) {
  const [opened, { close, open }] = useDisclosure(false);
  const [params, setParams] = useState<PickDevicesParams | undefined>(undefined);

  /**
   * Opens the modal for selecting the list of devices.
   */
  const pickDevices: PickDevices = (params) => {
    setParams(params);
    open();
  };

  return (
    <PickDevicesContext.Provider value={{ pickDevices }}>
      {children}
      {opened && <PickDevicesModal opened onClose={close} {...params!} />}
    </PickDevicesContext.Provider>
  );
}

/**
 * Hook for selecting the list of devices.
 */
export function usePickDevices() {
  return useContext(PickDevicesContext);
}
